export default __webpack_public_path__ + "static/media/OnlineCatalog.486c3655.pdf";